import React from "react";
import { Navigate } from "@tanstack/react-router";
import { usePaymentGetProfileStatus } from "./api/generated/sASOnlineClinicBackendAPI";
import { isGmoPaymentEnabled } from "./featureFlags";
import {
  hasPaymentFeatureDisabledMarker,
  isPaymentFeatureDisabledError,
} from "./payment/paymentFeatureDisabled";

export function PaymentRouteGuard({ children }: { children: React.ReactNode }) {
  const gmoPaymentEnabled = isGmoPaymentEnabled();
  const profileStatusQuery = usePaymentGetProfileStatus({
    query: {
      enabled: gmoPaymentEnabled,
    },
  });

  if (!gmoPaymentEnabled) {
    return <Navigate to="/patient/home" replace />;
  }

  if (isPaymentFeatureDisabledError(profileStatusQuery.error)) {
    return <Navigate to="/patient/home" replace />;
  }

  if (
    profileStatusQuery.data?.status === 200 &&
    hasPaymentFeatureDisabledMarker(
      (profileStatusQuery.data.data as any)?.requiredActions,
    )
  ) {
    return <Navigate to="/patient/home" replace />;
  }

  if (profileStatusQuery.isLoading) {
    return null;
  }

  return <>{children}</>;
}
